export class RedefinirSenhaDTO {
  novaSenha: string;
  confirmacaoSenha: string;
  idUsuario: any;
}
